export default __webpack_public_path__ + "static/media/blank.69d91881.jpg";